/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface PreFetchAPI
	 * @classdesc API class that defines PreFetch interface
	 */
	class PreFetchAPI {
		/**
		 * Get the pre-fetched response
		 * @param {string} id - the ID of the pre-fetched response
		 * @return {Promise} Resolved with the pre-fetched response
		 */
		get() { }

		/**
		 * Deletes the pre-fetched entry
		 * @param {string} id - the ID of the pre-fetched response
		 */
		clear() { }
	}

	return PreFetchAPI;
});
